import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockAlignSchema,
  TopolVertcalAlignSchema,
  TopolBlockSchema,
  TopolColorSchema,
  TopolColorBearingSchema,
} from "../commonSchema";

export const TopolArticleBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-article"),
  blockName: z.literal("article").catch("article"),
  attributes: z
    .object({
      "columns-layout": z
        .enum(["one-column", "text-image", "image-text"])
        .optional()
        .catch(undefined),

      // Image
      image: z
        .string()
        .trim()
        .catch(
          "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/pp1.png"
        ),
      "image-width": z.number().or(z.string()).catch(300),
      "image-alt": z.string().catch(""),
      "image-title": z.string().catch(""),
      "image-fluid-on-mobile": z
        .enum(["true", "false"])
        .optional()
        .catch(undefined),
      "image-align": TopolBlockAlignSchema.catch("center"),
      href: z.string().trim().catch(""),

      // Title
      title: z.string().catch(""),
      "raw-title": z.string().catch(""),
      "title-font-size": z.string().catch("13px"),
      "title-color": TopolColorSchema.catch("#000000"),
      "title-font-family": z.string().catch("Helvetica, Arial, sans-serif"),
      "title-font-weight": z.string().catch("normal"),
      "title-font-style": z.string().catch("normal"),
      "title-text-transform": z.string().catch("none"),
      "title-text-decoration": z.string().catch("none"),
      "title-padding": z.string().catch("0px 0px 0px 0px"),
      "title-align": TopolBlockAlignSchema.catch("center"),
      "title-line-height": z.number().optional().catch(undefined),
      "title-letter-spacing": z.string().optional().catch(undefined),

      // Published By
      "published-by": z.string().catch(""),
      "published-by-font-size": z.string().catch("13px"),
      "published-by-color": TopolColorSchema.catch("#000000"),
      "published-by-font-family": z
        .string()
        .catch("Helvetica, Arial, sans-serif"),
      "published-by-font-weight": z.string().catch("normal"),
      "published-by-font-style": z.string().catch("normal"),
      "published-by-text-transform": z.string().catch("none"),
      "published-by-text-decoration": z.string().catch("none"),
      "raw-published-by": z.string().catch(""),
      "published-by-padding": z.string().catch("0px 0px 0px 0px"),
      "published-by-align": TopolBlockAlignSchema.catch("center"),
      "published-by-line-height": z.number().optional().catch(undefined),
      "published-by-letter-spacing": z.string().optional().catch(undefined),

      // Published At
      "published-at": z.string().catch(""),
      "published-at-font-size": z.string().catch("13px"),
      "published-at-color": TopolColorSchema.catch("#000000"),
      "published-at-font-family": z
        .string()
        .catch("Helvetica, Arial, sans-serif"),
      "published-at-font-weight": z.string().catch("normal"),
      "published-at-font-style": z.string().catch("normal"),
      "published-at-text-transform": z.string().catch("none"),
      "published-at-text-decoration": z.string().catch("none"),
      "raw-published-at": z.string().catch(""),
      "published-at-iso": z.string().catch(""),
      "published-at-padding": z.string().catch("0px 0px 0px 0px"),
      "published-at-align": TopolBlockAlignSchema.catch("center"),
      "published-at-line-height": z.number().optional().catch(undefined),
      "published-at-letter-spacing": z.string().optional().catch(undefined),

      // Category
      category: z.string().catch(""),
      "category-font-size": z.string().catch("13px"),
      "category-color": TopolColorSchema.catch("#000000"),
      "category-font-family": z.string().catch("Helvetica, Arial, sans-serif"),
      "category-font-weight": z.string().catch("normal"),
      "category-font-style": z.string().catch("normal"),
      "category-text-transform": z.string().catch("none"),
      "category-text-decoration": z.string().catch("none"),
      "raw-category": z.string().catch(""),
      "category-padding": z.string().catch("0px 0px 0px 0px"),
      "category-align": TopolBlockAlignSchema.catch("center"),
      "category-line-height": z.number().optional().catch(undefined),
      "category-letter-spacing": z.string().optional().catch(undefined),

      // Description
      description: z.string().catch(""),
      "raw-description": z.string().catch(""),
      "description-padding": z.string().catch("0px 0px 0px 0px"),
      "description-font-size": z.string().catch("13px"),
      "description-color": TopolColorSchema.catch("#000000"),
      "description-font-family": z
        .string()
        .catch("Helvetica, Arial, sans-serif"),
      "description-font-weight": z.string().catch("normal"),
      "description-font-style": z.string().catch("normal"),
      "description-text-transform": z.string().catch("none"),
      "description-text-decoration": z.string().catch("none"),
      "description-align": TopolBlockAlignSchema.catch("center"),
      "description-line-height": z.number().optional().catch(undefined),
      "description-letter-spacing": z.string().optional().catch(undefined),

      // Layout
      layout: z.string().catch(""),
      dynamic: z.boolean().optional().catch(undefined),

      // Button
      "button-align": TopolBlockAlignSchema.catch("center"),
      "button-text-align": TopolBlockAlignSchema.optional().catch("center"),
      "button-background-color": TopolColorSchema.catch("#F5A623"),
      "button-gradient": TopolColorBearingSchema.optional().catch(undefined),
      "button-color": TopolColorSchema.catch("#ffffff"),
      "button-font-size": z.string().catch("13px"),
      "button-font-family": z.string().catch("Helvetica, Arial, sans-serif"),
      "button-font-weight": z.string().catch("normal"),
      "button-font-style": z.string().catch("normal"),
      "button-text-transform": z.string().catch("none"),
      "button-text-decoration": z.string().catch("none"),
      "button-border-radius": z.string().catch("3px"),
      "button-padding": z.string().catch("20px 20px 20px 20px"),
      "button-inner-padding": z.string().catch("10px 20px 10px 20px"),
      "button-width": z.enum(["auto", "100%"]).optional().catch("auto"),
      button: z.string().catch(""),
      containerWidth: z.number().catch(600),

      "image-border-radius": z.string().optional().catch(undefined),
      "image-padding": z.string().optional().catch(undefined),
      article_id: z.number().or(z.string()).optional().catch(undefined),
      article_feed_id: z.number().or(z.string()).optional().catch(undefined),
      "vertical-align": TopolVertcalAlignSchema.optional().catch(undefined),
      "css-class": TopolBlockCssClassSchema.optional().catch(undefined),
    })
    .default({} as any),
  "button-hover": z
    .object({
      "background-color": TopolColorSchema.optional().catch(undefined),
      color: TopolColorSchema.optional().catch(undefined),
      gradient: TopolColorBearingSchema.optional(),
    })
    .optional()
    .catch(undefined),
});

export type TopolArticleBlock = z.infer<typeof TopolArticleBlockSchema>;
